import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';
import { IRefreshTokenResponseApi } from '../interfaces/auth/auth.interface';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);
  private readonly alertService = inject(AlertService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status !== 401) {
          return throwError(() => error);
        }

        const refreshToken = sessionStorage.getItem('refreshToken');

        if (!refreshToken) {
          this.authService.logout();
          return throwError(() => error);
        }

        return this.authService.refreshToken(refreshToken).pipe(
          switchMap((res): Observable<HttpEvent<IRefreshTokenResponseApi>> => {
            sessionStorage.setItem('token', res.data.accessToken);
            sessionStorage.setItem('refreshToken', res.data.refreshToken);

            const clonedReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${res.data.accessToken}`
              }
            });

            return next.handle(clonedReq);
          })
        );
      })
    );
  }
}
